module.exports = __webpack_public_path__ + "front/img/gift.1cd26cac.png";